module.exports = __webpack_public_path__ + "static/media/done-theme.dfa24613.svg";